import { combineReducers } from "redux";

import Auth from "./auth/reducer";
import Layout from "./layout/reducer";
import Organisation from "./organisation/reducer";
import Items from "./items/reducer";
import Parties from "./parties/reducer";
import PurchaseOrders from "./purchase-orders/reducer";
import Reports from "./reports/reducer";
import Notification from "./Notification/reducer"

const rootReducer = combineReducers({
  Auth,
  Layout,
  Organisation,
  Reports,
  Items,
  Parties,
  PurchaseOrders,
  Notification
});

export default rootReducer;
